export const DASHBOARD_MODES = Object.freeze({
  EMBEDDED: 'embedded',
  HARDWARE: 'hardware',
  AUTO: 'auto'
});
